import React from 'react';
// import { ContextualSaveBar } from '@shopify/polaris';
import { ContextualSaveBar } from '@shopify/app-bridge-react'

const ContextSaveBar = ({
    message,
    saveAction,
    discardAction,
    visible,
}) => {
    return (
        <>
            {/* // <ContextualSaveBar
        //     message={message}
        //     saveAction={{
        //         content: saveAction.content,
        //         onAction: saveAction.onAction,
        //         loading: saveAction.loading || false,
        //         disabled: saveAction.disabled || false
        //     }}
        //     discardAction={{
        //         content: discardAction.content,
        //         onAction: discardAction.onAction,
        //         loading: discardAction.loading || false,
        //         disabled: discardAction.disabled || false
        //     }}
        //     visible={visible}
        // /> */}
            <ContextualSaveBar
                discardAction={{
                    content: "Discard",
                    loading: discardAction.loading || false,
                    disabled: discardAction.disabled || false,
                    onAction: discardAction.onAction
                }}
                saveAction={{
                    content: "Save",
                    loading: saveAction.loading || false,
                    disabled: saveAction.disabled || false,
                    onAction: saveAction.onAction
                }}
                visible={visible}
                message={message}
            />
        </>
    );
};

export default ContextSaveBar;